import { CreateDataExport, DataExport, DataExportResource, DataExportStatus } from 'model/dataExports';
import { CreateDataExportDto, DataExportDto } from './DataExportsDtos';

/**
 * The backend export catalog calls clients "customers"; every other resource
 * keeps the same key on both sides.
 */
const toBackendResource = (resource: DataExportResource): string => (resource === 'clients' ? 'customers' : resource);

const fromBackendResource = (resource: string): DataExportResource =>
    (resource === 'customers' ? 'clients' : resource) as DataExportResource;

export const convertToDataExport = (dto: DataExportDto): DataExport => ({
    id: dto.id,
    resource: fromBackendResource(dto.resource),
    status: dto.status as DataExportStatus,
    rowCount: dto.row_count,
    locationIds: dto.filters?.marketplace_ids ?? [],
    startDate: dto.filters?.start_date ?? null,
    endDate: dto.filters?.end_date ?? null,
    requestedBy: dto.requested_by?.name ?? null,
    createdAt: dto.created_at,
    completedAt: dto.completed_at,
    urlExpiresAt: dto.url_expires_at,
    downloadUrl: dto.download_url,
    failureReason: dto.failure_reason
});

export const convertToCreateDataExportDto = (dataExport: CreateDataExport): CreateDataExportDto => ({
    resource: toBackendResource(dataExport.resource),
    format: 'csv',
    marketplace_ids: dataExport.locationIds,
    start_date: dataExport.startDate,
    end_date: dataExport.endDate
});
